import Section1 from 'components/genieworksfamily/Section1';
import React from 'react';

const GenieworksFamily = () => {
  return <Section1 />;
};

export default GenieworksFamily;
